import React, {Component} from 'react';
import { Table, Glyphicon } from 'react-bootstrap';
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';
import axios from 'axios';
import PropTypes from 'prop-types';
import AppConstant from '../../../../../constants/app';

const SortableItem = SortableElement(({value}) =>
  <tr className="sortable-tr">
    <td className="sortable-td">{value.label}</td>
    <td className="sortable-td">{value.url}</td>
    <td className="sortable-td">
      <Glyphicon glyph="move" />
    </td>
  </tr>
);

const SortableList = SortableContainer(({items}) => {
  return (
    <Table className="menu-items-table">
      <tbody>
        {items.map((value, index) => (
          <SortableItem
            key={`item-${index}-table`}
            index={index}
            value={value}
          />
        ))}
      </tbody>
    </Table>
  );
});

class MenuLinksSortable extends Component {
  static propTypes = {
    linksList: PropTypes.array,
  };

  static defaultProps = {
    linksList: [],
  };

  state = {
    isLoaderOpened: false,
  };

  onSortEnd = ({oldIndex, newIndex}) => {
    const token = localStorage.getItem('token');
    const {
      onChangeLinksList,
      linksList,
    } = this.props;

    this.setState({ isLoaderOpened: true });
    
    const items = arrayMove(linksList, oldIndex, newIndex);

    axios({
      method: 'post',
      url: `${AppConstant.API_URL}/menu-items?access_token=${token}`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        menu_items: items.map((item, index) => ({
          id: item.id,
          position: index + 1,
        }))
      },
    })
    .then(res => {
      const items = res.data.header.menu_items;
      onChangeLinksList(items);
      this.setState({ isLoaderOpened: false });
    }).catch(err => {
      console.log(err);
    });
  };

  render() {
    const {
      isLoaderOpened,
    } = this.state;

    const {
      linksList,
    } = this.props;

    return (
      <div>
        {
          isLoaderOpened
          ? <p> Loading... </p>
          : <SortableList
              items={linksList}
              onSortEnd={this.onSortEnd}
              pressDelay={200}
            />
        }
      </div>
    );
  }
}

export default MenuLinksSortable;



// WEBPACK FOOTER //
// ./src/app/screens/general/headerContent/headerContentView/menuLinksSortable.js